// extracted by mini-css-extract-plugin
module.exports = {"categories-suggestions-title":"_3w1DH","categoriesSuggestionsTitle":"_3w1DH","title-text":"_3rOCC","titleText":"_3rOCC"};